<div class="container-fluid padding-top padding-bottom">
  <md-card *ngIf="unitSizes; else loading">
    <div class="row">
      <div class="col-md-12">
        <button class="btn btn-primary"
                color="primary"
                (click)="goBack()">Go Back</button>
      </div>
      <div class="col-md-12 text-center">
        <h1>{{ clientData?.name}}</h1>
        <h2>Size Guide Settings</h2>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <h5>Select a Location</h5>
        <div class="btn-group full-width"
             dropdown>

          <button class="btn btn-default btn-lg full-width btnCheckbox dropdown-toggle"
                  dropdownToggle
                  placement="right"
                  style="box-shadow: 0 0px 0px 0 rgba(0, 0, 0, 0);margin-right: 20px;"
                  type="button">

            {{selectedLocation ? selectedLocation.name : 'Select a Location'}}
          </button>
          <ul class="dropdown-menu dropdown-menu-right ng-star-inserted full-width"
              *dropdownMenu
              role="menu">

            <li role="menuitem"
                *ngFor="let location of locations | async">
              <a class="dropdown-item"
                 (click)="selectLocation(location)"
                 style="cursor: pointer;">
                <h5
                    style="padding: 0;-webkit-margin-before: 0em;-webkit-margin-after: 0em;font-size: 16px; font-weight: 600;">
                  {{location.name}}</h5>
                {{location?.address}}
                <br> {{location.address2}}
              </a>
              <hr style="margin-top: 0;margin-bottom: 0;">
            </li>
          </ul>

        </div>
        <div *ngIf="selectedLocation"
             class="text-center selected-location-card margin-top">
          <h5 style="margin-top: -10px;">{{selectedLocation?.name}}</h5>
          <p>{{selectedLocation?.address}}</p>
          <p>{{selectedLocation?.address2}}</p>
        </div>

      </div>
      <div class="col-md-8">
        <button (click)="updateLocationSizes()"
                *ngIf="selectedLocation"
                class="btn btn-primary float-right margin-bottom">Update Location</button>

        <table class="table table-bordered"
               *ngIf="selectedLocation">
          <thead>
            <tr>
              <th>Short Name</th>
              <th>Name</th>
              <th>On Location?</th>
              <th style="width: 140px;">
                <md-checkbox (change)="toggleAllSizesLocation($event)">
                </md-checkbox>&nbsp;Action
              </th>

            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let size of pageSettings?.sizeGuide?.sizes">
              <th scope="row"><b>{{size.shortName}}</b></th>
              <td>{{size.name}}</td>
              <td class="text-center">
                <i *ngIf="locationIndex[selectedLocation.$key] && locationIndex[selectedLocation.$key][size.index]"
                   class="fa fa-check-circle"
                   style="color: #31B896;font-size: 25px;"></i>

              </td>
              <td>
                <md-checkbox [(ngModel)]="selectedLocationSizesToAdd[size.index]"
                             style="font-size: 22px;">Add Size</md-checkbox>
              </td>


            </tr>
          </tbody>
        </table>

      </div>

    </div>



    <div class="row margin-top">
      <div class="col-md-12 sm-padding-top">
        <h5>Size Guide</h5>
        <button class="btn btn-accent"
                (click)="fillSizeData()">Fill with Facility Sizes</button>
        <button class="btn btn-primary"
                (click)="fillSizeDefaultData()">Fill with Default Sizes</button>
        <p>*** Doing this will also remove any location Size Guide options selected. ***</p>
        <hr>
        <scs-new-size-guide-sizes [pageSettings]="pageSettings"
                                  [clientData]="clientData"></scs-new-size-guide-sizes>
      </div>
    </div>



  </md-card>
</div>

<ng-template #loading>
  <div class="spinner">
    <md-spinner color="accent"></md-spinner>
  </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/size-guide/size-guide.component.html